import { OptionalIndicationYesNoOptions } from "../helpers";

import { BasicMetadata, BroIdMetadata, EditMetadata } from "./MetaData";
import { Task } from "./Task";

export const gpdMethodOptions = [
  {
    value: "berekening",
    label: "Berekening",
  },
  {
    value: "watermeter",
    label: "Watermeter",
  },
  {
    value: "onbekend",
    label: "Onbekend",
  },
] as const;
export type GpdMethodOptions = (typeof gpdMethodOptions)[number]["value"];

export const gpdWaterInOutOptions = [
  {
    value: "ingebracht",
    label: "Ingebracht",
  },
  {
    value: "onttrokken",
    label: "Onttrokken",
  },
] as const;
export type GpdWaterInOutOptions = (typeof gpdWaterInOutOptions)[number]["value"];

export const gpdTemperatureOptions = [
  {
    value: "warm",
    label: "Warm",
  },
  {
    value: "koud",
    label: "Koud",
  },
  {
    value: "onbekend",
    label: "Onbekend",
  },
] as const;
export type GpdTemperatureOptions = (typeof gpdTemperatureOptions)[number]["value"];

export interface GPDStartRegistrationData {
  objectIdAccountableParty: string;
  publiclyAvailable?: OptionalIndicationYesNoOptions;
}

export interface GPDVolumeSeriesData {
  waterInOut: GpdWaterInOutOptions;
  volume: number;
  temperature?: GpdTemperatureOptions;
  beginDate: string;
  endDate: string;
}

export interface GPDAddReportData {
  reportId: string;
  method: GpdMethodOptions;
  volumeSeries: GPDVolumeSeriesData[];
  groundwaterUsageFacilityBroId: string;
}

export type GPDStartRegistrationTask = Task<GPDStartRegistrationData, BasicMetadata>;
export type EditGPDStartRegistrationTask = Task<GPDStartRegistrationData, EditMetadata>;

export interface GPDAddReportTask extends Task<GPDAddReportData, BroIdMetadata> {
  volumeFile: Blob;
}

export interface EditGPDAddReportTask extends Task<GPDAddReportData, EditMetadata> {
  volumeFile: Blob;
}

export type GPDEndRegistrationTask = { metadata: BroIdMetadata };
